export function buildReturnToPath(locationLike = {}) {
  const pathname = typeof locationLike?.pathname === 'string' ? locationLike.pathname : '';
  const search = typeof locationLike?.search === 'string' ? locationLike.search : '';
  const hash = typeof locationLike?.hash === 'string' ? locationLike.hash : '';
  const path = `${pathname}${search}${hash}`.trim();
  return isSafeReturnTo(path) ? path : '';
}

export function isSafeReturnTo(value) {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//');
}

export function resolveReturnTo({ location, fallback = '/home' } = {}) {
  const stateReturnTo = location?.state?.returnTo;
  if (isSafeReturnTo(stateReturnTo)) return stateReturnTo;

  const params = new URLSearchParams(location?.search || '');
  const queryReturnTo = params.get('returnTo');
  if (isSafeReturnTo(queryReturnTo)) return queryReturnTo;

  return fallback;
}

export function buildAuthNavigationTarget(basePath, returnTo = '') {
  const safeBasePath = typeof basePath === 'string' && basePath.startsWith('/') ? basePath : '/signin';
  if (!isSafeReturnTo(returnTo)) return safeBasePath;
  return `${safeBasePath}?returnTo=${encodeURIComponent(returnTo)}`;
}
